/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { get, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default class AdminCard extends Component {
  @service
  session;

  @service
  features;

  @service
  permissions;

  @service
  strings;

  // goal is the goal/topic to be displayed.
  goal = null;

  // isSortable flags that this card is in a sortable list.
  isSortable = false;

  // readOnly removes all action buttons.
  readOnly = false;

  // Class is appended to the top level of the md-card
  class = '';

  // edit is the action to perform when the edit button is clicked.
  edit() {}

  // confirmDelete is the action to perform when the delete button is clicked.
  confirmDelete() {}

  @alias('goal.subject.isTopic')
  isTopic;

  @alias('features.sidekickEnabled')
  sidekickEnabled;

  @computed('session.scopes.[]')
  get isTenantAdmin() {
    return this.permissions.meet(Scopes.TENANT_ADMIN);
  }

  goalLinkedGoals = [];

  @computed('goal.linkedGoalIds.[]')
  get groupedGoals() {
    let groupedGoals = {};
    this.goal.get('linkedGoalIds').forEach((goal) => {
      if (goal) {
        let subject = get(goal, 'subjectId');
        let subjectType = get(subject, 'subjectTypeName') || 0;
        // Initialize the array for this key if it doesn't exist yet
        if (!groupedGoals[subjectType]) {
          groupedGoals[subjectType] = 0;
        }
        // Increment the count for the corresponding key
        groupedGoals[subjectType]++;
      }
    });
    return groupedGoals;
  }

  // showSidekickCode determines whether to display the Sidekick QR code.
  @computed('sidekickEnabled', 'goal.{subject.isTopic,linkedGoalIds.[]}')
  get showSidekickCode() {
    if (!this.sidekickEnabled) {
      // Never render Sidekick QR codes if Sidekick isn't enabled.
      return false;
    }
    if (this.isTopic) {
      // For Topics, only render the code if there are any linked goal IDs.
      return !isEmpty(this.goal.linkedGoalIds);
    }
    // For regular goals, render the code as long as Sidekick is enabled.
    return true;
  }
}
